import { useState, useContext, useEffect } from "react";
import { SidebarContext } from "../../context/SidebarContext";
import { MdOutlineMenu } from "react-icons/md";
import img from "../../assets/images/paytrix-symbol-white.png";
import kwicpeName from "../../assets/images/paytrix-wordmark-white.png";
import shield from "../../assets/images/shield.png";
import AccountModal from "./AccountModal";
import "./Account.css";
import { getWebhook, createWebhook } from "../../config/LiveApi";
import { CiEdit } from "react-icons/ci";
import { toast } from "react-toastify";
import { ShimmerSectionHeader } from "react-shimmer-effects";
import { useSelector } from "react-redux";

const AccountPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { openSidebar } = useContext(SidebarContext);
  const [copiedText, setCopiedText] = useState("");
  const name = useSelector((store) => store.userReducer.userName);
  const email = useSelector((store) => store.userReducer.userEmail);
  const id = useSelector((store) => store.userReducer.userId);
  const phoneNumber = useSelector((store) => store.userReducer.userPhoneNumber);
  const [payinURL, setPayinURL] = useState("");
  const [payoutURL, setPayoutURL] = useState("");
  let [payinInput, setPayinInput] = useState("");
  let [payoutInput, setPayoutInput] = useState("");
  const [isEditingPayin, setIsEditingPayin] = useState(false);
  const [isEditingPayout, setIsEditingPayout] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [activeContainer, setActiveContainer] = useState(
    "webhook-account-container",
  );

  const role = useSelector((store) => store.userReducer.role);
  const token = useSelector((store) => store.userReducer.token);

  const myFunction = () => {
    if (id) {
      navigator.clipboard
        .writeText(id)
        .then(() => {
          alert("Copied the text: " + id);
          setCopiedText(id);
        })
        .catch((error) => {
          console.error("Failed to copy: ", error);
          alert("Failed to copy text. Please try again.");
        });
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const fetchWebhook = async (token) => {
    setIsLoading(true);
    try {
      const webhookRes = await getWebhook(token);

      setPayinURL(webhookRes.payinURL || "");
      setPayoutURL(webhookRes.payoutURL || "");
    } catch (err) {
      // console.error("Failed to fetch webhooks:", err);
      toast.error("Unable to fetch webhooks. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    if (
      (isEditingPayin || payinInput !== "") &&
      (isEditingPayout || payoutInput !== "")
    ) {
      setIsLoading(true);
      try {
        if (!confirm("Are you sure, you want to change both webook URL?"))
          return;

        await createWebhook(token, {
          payinURL: payinInput,
          payoutURL: payoutInput,
        });
        fetchWebhook(token);
        toast.success("URL updated successfully.");
        setIsEditingPayin(false);
        setIsEditingPayout(false);
      } catch (err) {
        console.error(err.message);
        toast.error("URL could not be updated.");
      } finally {
        setIsLoading(false);
      }
    } else if (isEditingPayin || payinInput !== "") {
      setIsLoading(true);

      try {
        if (!confirm("Are you sure, you want to change payin webook URL?"))
          return;
        await createWebhook(token, {
          payinURL: payinInput,
          payoutURL: payoutURL,
        });
        fetchWebhook(token);
        toast.success("Payin URL updated successfully.");
        setIsEditingPayin(false);
      } catch (err) {
        console.error(err.message);
        toast.error("Payin URL could not be updated.");
      } finally {
        setIsLoading(false);
      }
    } else if (isEditingPayout || payoutInput !== "") {
      setIsLoading(true);
      try {
        if (!confirm("Are you sure, you want to change payout webook URL?"))
          return;
        await createWebhook(token, {
          payinURL: payinURL,
          payoutURL: payoutInput,
        });
        fetchWebhook(token);
        toast.success("Payout URL updated successfully.");
        setIsEditingPayout(false);
      } catch (err) {
        console.error(err.message);
        toast.error("Payout URL could not be updated.");
      } finally {
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchWebhook(token);
  }, []);

  const displayContainer = (container) => {
    setActiveContainer(container);
  };

  const handleCancel = () => {
    setIsEditingPayin(false);
    setPayinInput("");
    setIsEditingPayout(false);
    setPayoutInput("");
  };

  return (
    <>
      {/* {(role == "super" ||
        role == "operation" ||
        role == "subSuper" ||
        role === "admin") && (
        <nav className="navbar-accounts">
          <div className="nav-links-accounts">
            {role === "admin" && (
              <NavLink to="/account" className="active-accounts">
                Accounts
              </NavLink>
            )}
            {(role == "super" || role == "operation" || role == "subSuper") && (
              <NavLink to="/merchant-webhooks">Webhooks</NavLink>
            )}
            {(role == "super" || role == "operation" || role == "subSuper") && (
              <NavLink to="/api-key">API Keys</NavLink>
            )}
            {role === "admin" && <NavLink to="/ips-merchant">IPs</NavLink>}
          </div>
        </nav>
      )} */}
      <div className="main-div-alt">
        <div className="content-area">
          <div className="area-top-l">
            <button
              className="sidebar-open-btn"
              type="button"
              onClick={openSidebar}
            >
              <MdOutlineMenu size={24} />
            </button>
            <h2 className="area-top-title">Account</h2>
          </div>

          <div className="card">
            <div className="card__front card__part">
              <img className="card__front-square card__square" src={img} alt="Paytrix" />
              <img className="card__front-logo card__logo" src={kwicpeName} alt="Paytrix" />
              <div
                className="card__front-logo1 card_logo"
                style={{ display: "flex" }}
              >
                <img height={18} width={18} src={shield} />
                <p style={{ color: "white", fontSize: "12px" }}>Verified</p>
              </div>
              <div className="card_numer">
                <p>{name}</p>
              </div>

              <div className="card__space-75">
                <span className="card__label">Email Id</span>
                <p className="card__info">{email}</p>
              </div>
              <div className="card__space-25">
                <span className="card__label">Mobile Number</span>
                <p className="card__info">{phoneNumber}</p>
              </div>
            </div>

            <div className="card__back card__part">
              <div className="card__black-line"></div>
              <div className="card__back-content">
                <p className="card__label">Merchant Id</p>
                <div className="card-sec-button">
                  <div className="card__secret">
                    <p className="text-size">{id}</p>
                  </div>
                  <button className="copy-button-1" onClick={myFunction}>
                    Copy
                  </button>
                </div>

                <img className="card__back-square card__square" src={img} alt="Paytrix" />
                <img className="card__back-logo card__logo" src={kwicpeName} alt="Paytrix" />
              </div>
            </div>
          </div>

          <AccountModal open={isModalOpen} handleClose={handleCloseModal} />
        </div>

        {role === "admin" && (
          <div className="webhook-div-main">
            <div
              className="webhook-account-container"
              style={{
                display:
                  activeContainer === "webhook-account-container"
                    ? "block"
                    : "none",
              }}
            >
              <div className="content-area">
                {isLoading ? (
                  <>
                    <ShimmerSectionHeader center />{" "}
                    <ShimmerSectionHeader center />
                  </>
                ) : (
                  <div data-tour="webhook-urls" className="webhook-containers">
                    <div>
                      <p className="head-webhook">Webhook</p>
                      <p className="label-data">Payin URL : </p>
                      {isEditingPayin || !payinURL ? (
                        <div className="input-url">
                          <div className="input-field-container">
                            <input
                              type="text"
                              value={payinInput}
                              onChange={(e) => setPayinInput(e.target.value)}
                              placeholder="Enter Payin URL..."
                            />
                            <CiEdit
                              className="edit-btn-webhook-section"
                              onClick={() => {
                                setPayinInput(payinURL);
                                setIsEditingPayin(true);
                              }}
                            />
                          </div>
                        </div>
                      ) : (
                        <div className="input-url">
                          <div className="input-field-container">
                            <input
                              type="text"
                              value={payinURL}
                              onChange={(e) => setPayinInput(e.target.value)}
                              placeholder="Enter Payin URL..."
                              readOnly={!isEditingPayin}
                              className="input-with-icon"
                            />
                            <CiEdit
                              size={20}
                              onClick={() => {
                                setPayinInput(payinURL);
                                setIsEditingPayin(true);
                              }}
                              className="edit-icon"
                            />
                          </div>
                        </div>
                      )}
                    </div>

                    <div>
                      <p className="label-data">Payout URL : </p>
                      {isEditingPayout || !payoutURL ? (
                        <div className="input-url">
                          <div className="input-field-container">
                            <input
                              type="text"
                              value={payoutInput}
                              onChange={(e) => setPayoutInput(e.target.value)}
                              placeholder="Enter Payout URL..."
                            />
                            <CiEdit
                              className="edit-btn-webhook-section"
                              onClick={() => {
                                setPayoutInput(payoutURL);
                                setIsEditingPayout(true);
                              }}
                            />
                          </div>
                        </div>
                      ) : (
                        <div className="input-url">
                          <div className="input-field-container">
                            <input
                              type="text"
                              value={payoutURL}
                              onChange={(e) => setPayoutInput(e.target.value)}
                              readOnly={!isEditingPayout}
                              className="input-with-icon"
                            />
                            <CiEdit
                              size={20}
                              onClick={() => {
                                setPayoutInput(payoutURL);
                                setIsEditingPayout(true);
                              }}
                              className="edit-icon"
                            />
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="btn-div-webhook">
                      {(isEditingPayin || isEditingPayout) && (
                        <button
                          className="webhook-cancel-btn"
                          onClick={handleCancel}
                        >
                          Cancel
                        </button>
                      )}
                      <button
                        className="webhook-update-btn"
                        onClick={handleUpdate}
                      >
                        Update
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default AccountPage;